'use strict';

/**
* FUNCTION: defaults()
*	Returns default options.
*
* @returns {Object} default options
*/
function defaults() {
	return {
		'create': false,
		'sep': '.'
	};
} // end FUNCTION defaults()


// EXPORTS //

module.exports = defaults;
